import type { ReportDefinition } from "@/types";

export const REPORTS: ReportDefinition[] = [
  {
    id: "report-daily-brief",
    name: "Daily COO Brief",
    cadence: "daily",
    description: "A one-page snapshot of overnight changes: new alerts, revenue movement, escalations, and approvals awaiting decision.",
    lastGenerated: new Date().toISOString(),
    sections: ["Overnight Alerts", "Revenue Snapshot", "Escalations", "Pending Approvals", "Today's Priorities"],
  },
  {
    id: "report-weekly-summary",
    name: "Weekly Executive Summary",
    cadence: "weekly",
    description: "Week-over-week performance across revenue, clients, operations, and people with commentary.",
    lastGenerated: new Date(Date.now() - 2 * 86400000).toISOString(),
    sections: ["Revenue vs Target", "Client Health Movement", "Operational KPIs", "People Highlights", "Risks & Wins"],
  },
  {
    id: "report-monthly-review",
    name: "Monthly Business Review",
    cadence: "monthly",
    description: "Comprehensive monthly performance review suitable for board and leadership distribution.",
    lastGenerated: new Date(Date.now() - 9 * 86400000).toISOString(),
    sections: ["Financial Performance", "Client Portfolio", "Departmental Scorecards", "Strategic Initiatives", "Outlook"],
  },
  {
    id: "report-client-risk",
    name: "Client Risk Report",
    cadence: "weekly",
    description: "Full breakdown of at-risk and critical accounts with mitigation status.",
    lastGenerated: new Date(Date.now() - 1 * 86400000).toISOString(),
    sections: ["Critical Accounts", "High-Risk Accounts", "Mitigation Plans", "Renewal Exposure"],
  },
  {
    id: "report-revenue",
    name: "Revenue Report",
    cadence: "monthly",
    description: "Detailed revenue performance, forecast accuracy, and breakdown by AM, industry, and department.",
    lastGenerated: new Date(Date.now() - 4 * 86400000).toISOString(),
    sections: ["MRR Trend", "Forecast vs Actual", "Revenue by Segment", "Expansion Pipeline"],
  },
  {
    id: "report-people",
    name: "People Report",
    cadence: "monthly",
    description: "Headcount, attrition, hiring funnel, and performance distribution across the organization.",
    lastGenerated: new Date(Date.now() - 6 * 86400000).toISOString(),
    sections: ["Headcount & Bench", "Recruiting Funnel", "Attrition Analysis", "Performance Distribution"],
  },
  {
    id: "report-operations",
    name: "Operations Report",
    cadence: "weekly",
    description: "Delivery health, SLA compliance, and capacity across all client-facing pods.",
    lastGenerated: new Date(Date.now() - 3 * 86400000).toISOString(),
    sections: ["SLA Compliance", "Capacity Heatmap", "Escalation Trends", "Training Gaps"],
  },
];
